import { Component, Input, OnInit } from '@angular/core';
import { AttachedFile } from 'src/app/domain/attachedFile';
import { FileUtility } from '../../file-utility';

@Component({
    selector: 'app-file-display',
    templateUrl: './file-display.component.html',
    styleUrls: ['./file-display.component.scss']
})
export class FileDisplayComponent implements OnInit {

    @Input() file!: AttachedFile;
    @Input() IsFinished!: boolean;

    constructor(private fileUtility: FileUtility) { }

    ngOnInit(): void {
    }

    ViewDocument() {
        this.fileUtility.ViewDocument(this.file);
    }

    DownloadDocument() {
        this.fileUtility.DownLoadDocument(this.file);
    }
}
